export default __webpack_public_path__ + "static/bridal-edit-banner-42dc83c29b1dee8107438bab3e7061d2.webp";